module.exports = __webpack_public_path__ + "static/media/loc_img_form.1f1af43b.png";